import { render, staticRenderFns } from "./TeamClient.vue?vue&type=template&id=6332c7c0&scoped=true"
import script from "./TeamClient.vue?vue&type=script&lang=js"
export * from "./TeamClient.vue?vue&type=script&lang=js"
import style0 from "./TeamClient.vue?vue&type=style&index=0&id=6332c7c0&prod&scoped=true&lang=less"
import style1 from "./TeamClient.vue?vue&type=style&index=1&id=6332c7c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6332c7c0",
  null
  
)

export default component.exports